import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useI18n } from '@/lib/i18n';
import { type RulesSearch, RulesSearchSchema, RulesWorkspacePage } from '@/routes/rules';

export const Route = createFileRoute('/order-confirmations/rules')({
  validateSearch: (search) => RulesSearchSchema.parse(search),
  component: OrderConfirmationRulesPage,
});

function OrderConfirmationRulesPage() {
  const { t } = useI18n();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <RulesWorkspacePage
      search={search}
      copy={{
        sectionLabel: t('orderConfirmationRules.sectionLabel'),
        pageTitle: t('orderConfirmationRules.pageTitle'),
        pageDescription: t('orderConfirmationRules.pageDescription'),
      }}
      onSearchChange={(updater, replace = false) => {
        void navigate({
          replace,
          search: (prev) => updater(prev as RulesSearch),
        });
      }}
    />
  );
}
